import React from 'react';
import { connect } from 'react-redux';
import { selectModel, selectResources } from '../store/selectors';
import { LoadingSpinner } from 'flos-react-cvi';
import { initReceiptPage, errorOut } from '../store/thunks';
import { ReceiptContainer } from '../components/receipt-container';
import { Receipt } from '../components/receipt';

const ReceiptPageView = ({ resources, init, throwError }) => {
    const [receiptInfo, setReceiptInfo] = React.useState(null);

    React.useEffect(() => {
        setTimeout(() => {
            init()
                .then(({ object }) => {
                    setReceiptInfo(object);
                })
                .catch(err => throwError(err));
        }, 1500);
    }, [init, throwError]);

    if (!receiptInfo) {
        return <LoadingSpinner />;
    }

    return (
        <>
            <ReceiptContainer resources={resources} customerEmail={receiptInfo.customer.email} />
            <Receipt resources={resources} receiptInfo={receiptInfo} />
        </>
    );
};

const mapStates = state => {
    const model = selectModel(state);

    return {
        resources: selectResources(state),
        show: !!model,
        dealPrice: model && model.dealPrice
    };
};

const mapDispatch = {
    init: initReceiptPage,
    throwError: errorOut
};

export const ReceiptPage = connect(mapStates, mapDispatch)(ReceiptPageView);
